export const iconFontAwesomeSecurityBug = (
	<i className="fa-solid fa-bug"></i>
);
